var allResults = {};

function printResults(simulator){
    console.log(JSON.stringify({"values": allResults, "events": simulator.passedEvents}));
}

function getSTAMPriority(simulator){
    var readyTasks = simulator.projectPool.getAllReadyTasks(simulator.projectPool.projects);
    
    var simVals = getSimulationValues(simulator);
    var sgVals = getSkillGroupValues(simulator, simVals);
    var projectVals = simulator.projectPool.projects.filter(project => !project.isFinished()).map((project, index) => getProjectValues(simulator, project, index));

    var stamValues = [];
    Object.keys(sgVals.sPB).forEach((key) => {
        if(checkAllZero(sgVals.sPB)){
            stamValues.push({"value": -sgVals.highestNeededFlow[key], "type": "resource", "key" : key});
        }
        stamValues.push({"value": sgVals.sPB[key], "type": "resource", "key" : key});
    });

    projectVals.forEach((projectVal, index) => {
        stamValues.push({"value": projectVal.pPB, "type": "project", "key" : index});
    });

    stamValues.sort((stamVal1, stamVal2) => {
        return stamVal1.value - stamVal2.value;
     });



    
    var ordereredTasks = stamValues.map((stamVal) => getSTAMTasks(simulator, stamVal));
    var mergedOrdereredTasks = ordereredTasks.reduce(function(prev, next) {
        return prev.concat(next);
      })

    mergedOrdereredTasks = mergedOrdereredTasks.filter(function(item, pos) {
        return mergedOrdereredTasks.indexOf(item) == pos;
    })

    var printResults = mergedOrdereredTasks.map((task) => {return {"task": task.taskName, "projectIndex": task.project.projectIndex}});
    allResults[simulator.hoursPassed] = {"simVals": simVals, "sgVals": sgVals, "projectVals": projectVals, "stamValues": stamValues, "ordereredTasks": printResults};

    return mergedOrdereredTasks;
}

function getSTAMTasks(simulator, STAMDict){
    var readyTasks = simulator.projectPool.getAllReadyTasks(simulator.projectPool.projects);
    
    if(STAMDict.type == "project"){
        readyTasks = readyTasks.filter((task) => task.project.projectIndex == STAMDict.key);
    }

    if(STAMDict.type == "resource"){
        readyTasks = getSupportingTask(simulator, STAMDict.key);
    }

    return readyTasks;
}

function getSupportingTask(simulator, resourceID){
    var readyTasks = simulator.projectPool.getAllReadyTasks(simulator.projectPool.projects);
    
    var minSupportHours = [];

    readyTasks.forEach((task) => {
        var minHour = 100000;
        project = task.project.taskArray.forEach((supportTask) => {
            if(supportTask.resourceGroupID == resourceID){
                minHour = Math.min(minHour, supportTask.startHour);
            }
        });

        minSupportHours.push({hour: minHour, task: task});
    });

    minSupportHours.sort((minSupportHour1, minSupportHour2) => {
        return minSupportHour1.hour - minSupportHour2.hour;
    });


    return minSupportHours.map((minSupportHour) => minSupportHour.task);
}

function getWork(sgVals, projectVals){
    var skillGroupResults = lowestValueAndKey(sgVals.sPB);
    if(checkAllZero(sgVals.sPB)){
        console.log("First iteration")
        var skillGroupResults = highestValueAndKey(sgVals.highestNeededFlow);
        console.log("Supporting skill group: " + skillGroupResults.key + " with value: " + skillGroupResults.value);
    }
    else{
        var projectResults = lowestValueAndKey(Object.fromEntries(projectVals.map((projectVal, index) => [index, projectVal.pPB])));

        if(projectResults.value < skillGroupResults.value){
            console.log("Supporting project: " + projectResults.key + " with value: " + projectResults.value);
        }
        else{
            console.log("Supporting skill group: " + skillGroupResults.key + " with value: " + skillGroupResults.value);
        }
    }
}



function checkAllZero(sPB){
    return Object.values(sPB).every((val) => val == 0);
}

function getSkillGroupValues(simulator, simVals){
    //Get all the resources
    var sI = simulator.resourcePool.getCurrentCapacities();
    var asI = simulator.resourcePool.getCurrentCapacities();

    var results = getAllWorkHours(simulator);
    var sDP = results.workHours;

    var sOR = mapOverDict(sDP, (key) => {return sDP[key] / simVals.rt});
    var sIB = mapOverDict(asI, (key) => {return asI[key] - sOR[key]});

    var sDPf = mapOverDict(sI, (key) => {return getFinishedWork(simulator, key)});

    var stf = mapOverDict(sDPf, (key) => {return getLeftProject(simulator)});

    var sOR_stf = mapOverDict(sOR, (key) => {return sOR[key] * stf[key]});

    var sPB = mapOverDict(sDPf, (key) => {return sDPf[key] - sOR_stf[key]});
    var sIF = mapOverDict(sPB, (key) => {return sPB[key] / simVals.rt});
    var IF = lowestValueAndKey(sIF).value;

    var highestNeededFlow = mapOverDict(sDP, (key) => {return sDP[key] / asI[key]});
    var sPR = mapOverDict(sPB, (key) => {return sPB[key] / sOR_stf[key]});
    var lowestRelativeProgress = lowestValueAndKey(sPR).value;

    return {sI, asI, sDP, sOR, sIB, sDPf, stf, sOR_stf, sPB, sIF, IF, highestNeededFlow, sPR, lowestRelativeProgress};
}

function getLeftProject(simulator){
    //Get the start point of the earliest not finished project
    var startHour = 100000;
    simulator.projectPool.projects.forEach((project) => {

        if(project.isFinished()){
            return;
        }

        startHour = Math.min(startHour, project.startHour);
    })

    return startHour;
}

function getProjectValues(simulator, project, index){
    var pDP = project.longestChainLength;
    var lt = project.leadTimeHours;
    var pOR = pDP / lt;
    var ptf = simulator.hoursPassed - project.startHour;
    var pOR_ptf = pOR * ptf;
    var pDPf = getpDPf(simulator, project);
    var pPB = pDPf - pOR_ptf;
    var pPR = pPB / pOR_ptf;
    var remtime = lt - ptf;
    var remchain = pDP - pDPf;
    var oNF = remchain / remtime;

    return {pDP, lt, pOR, ptf, pOR_ptf, pDPf, pPB, pPR, remtime, remchain, oNF};
}

function getpDPf(simulator, project){
    var remainingChainLength = project.getMinimumEndHour() - project.startHour - simulator.hoursPassed;
    return project.longestChainLength - remainingChainLength;
}

function lowestValueAndKey(obj) {
    var [lowestItems] = Object.entries(obj).sort(([ ,v1], [ ,v2]) => v1 - v2);
    return {key: lowestItems[0], value: lowestItems[1]};
  }

function highestValueAndKey(obj) {
    var [highestItems] = Object.entries(obj).sort(([ ,v1], [ ,v2]) => v2 - v1);
    return {key: highestItems[0], value: highestItems[1]};
  }

function getAllFinishedWorkPerProject(project){
    var finishedWork = 0;
    project.taskArray.forEach(task => {
        finishedWork += task.currWorkedHours;
    })

    return finishedWork;
}

function getFinishedWork(simulator, key){
    var workHours = 0;
    simulator.projectPool.projects.forEach(project => {
        project.taskArray.forEach(task => {
            if(task.resourceGroupID == key){
                workHours += task.currWorkedHours;
            }
        })
    })

    return workHours;
}

function mapOverDict(dict, func){
    return Object.fromEntries(Object.keys(dict).map(key => {return [key, func(key)]}) )
}

function getSimulationValues(simulator){
    var results = getAllWorkHours(simulator);
    var outputArray = results.output;
    var output = getArraySum(outputArray);
    var leadTimes = getAllLeadtimes(simulator);
    var flowArray = getFlowArray(leadTimes, outputArray);
    var flow = getArraySum(flowArray);
    var I = getArraySum(Object.values(simulator.resourcePool.getCurrentCapacities()));
    var rt = output / flow;
    var availability = I * rt;
    var efficiency = output / availability;
    var buffer = availability - output;
    var outputRate = output / rt;
    var capacityBuffer = I - outputRate;
    var processTime = output / I;
    var timeBuffer = rt - processTime;
    var tradyOff = capacityBuffer * timeBuffer;

    return {outputArray, output, leadTimes, flowArray, flow, I, rt, availability, efficiency, buffer, outputRate, capacityBuffer, processTime, timeBuffer, tradyOff};
}

function getArraySum(array){
    return array.reduce((partialSum, a) => partialSum + a, 0);
}

function getFlowArray(leadTimes, DPArray){
    return leadTimes.map((_, index) => {
        return DPArray[index] / leadTimes[index];
    });
}

function getAllLeadtimes(simulator){
    return simulator.projectPool.projects.filter(project => !project.isFinished()).map(project => {return project.leadTimeHours});
}

function getAllWorkHours(simulator){
    var workHours = {B: 0, O: 0, I: 0, M: 0, A: 0, P: 0};
    var output = [];
    simulator.projectPool.projects.filter(project => !project.isFinished()).forEach(project => {


        var totalProjectHours = 0;
        project.taskArray.forEach(task => {
            workHours[task.resourceGroupID] += task.totalWorkHours;
            totalProjectHours += task.totalWorkHours;
        })

        output.push(totalProjectHours);
    });

    return {workHours: workHours, output: output};
}

module.exports = {getSTAMPriority, printResults}